module.exports = __webpack_public_path__ + "media/images/emblems/Chigny-coat_of_arms-b4bf31d33447bc220db28790de0dea78.svg";